// extracted by mini-css-extract-plugin
export default {"miniTile":"EnergyTrackerReportPage_miniTile__GhRXb","title":"EnergyTrackerReportPage_title__s-zTc","twoColumns":"EnergyTrackerReportPage_twoColumns__8rcur"};